import React, {useEffect} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import {useHistory} from 'react-router-dom'
import CrearUsuario from '../../GestionUsuarios/CrearUsuario/Components/CrearUsuario'
import AgregarClienteManual from './Components/AgregarClienteManual'
import {useDispatch, useSelector} from 'react-redux'
import {
  gu_cu_ChangePage,
  gu_cu_Clear,
} from '../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import {State} from '../../../reducers'
import ModalsControls from '../../GestionUsuarios/CrearUsuario/modals/ModalsControls'
import {facturacionFormClienteClear} from '../../../actions/facturacion/facturacionCliente.actions'

const CrearUsuarioIndex = () => {
  const page = useSelector((state: State) => state.gestionUsuario.creacionUsuario.paginaActual)
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    window.scroll(0, 0)
    dispatch(gu_cu_ChangePage(0))
    return () => {
      dispatch(gu_cu_Clear())
      dispatch(facturacionFormClienteClear())
      dispatch(gu_cu_ChangePage(0))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    window.scroll(0, 0)
  }, [page])

  const back = () => {
    if (page > 0) dispatch(gu_cu_ChangePage(-1))
    else history.push('/gestion-clientes')
  }

  return (
    <BasicLayout>
      <ModalsControls />
      <div
        id='w-node-_37c4edc4-e645-30b8-cee7-f036e602dada-04e476cd'
        className='w-layout-cell w-100'
      >
        <div className='header'>
          <button className='back-button w-inline-block' onClick={back}></button>
          <h3 className='h3-titles xl'>Agregar cliente</h3>
        </div>
        <div className='separador'></div>
        <AgregarClienteManual />
      </div>
    </BasicLayout>
  )
}

export default CrearUsuarioIndex
